import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Input from "@mui/joy/Input";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";
import { useForm, Controller } from "react-hook-form";

import { addProposal } from "../requests/proposals";

const Proposals = () => {
  const [message, setMessage] = useState("");
  const [buttonState, setButtonState] = useState("WYŚLIJ PROPOZYCJE");
  const prevYear = new Date().getFullYear() - 1;
  const {
    handleSubmit,
    control,
    formState: { isSubmitSuccessful, isLoading, errors },
  } = useForm({
    defaultValues: {
      arysta: "",
      producent: "",
      dj: "",
      album: "",
      teledysk: "",
      impreza: "",
      wydarzenie: "",
      email: "",
    },
  });
  const navigate = useNavigate();

  const handleSubmitForm = async (data) => {
    console.log(data);
    try {
      await addProposal(data).then(() => {
        setMessage(
          "Dziękujemy za zgłoszenie propozycji! Rozpoczęcie drugiego etapu 2 kwietnia 2025."
        );
        setButtonState("WYSŁANO");
      });
    } catch (error) {
      console.log(error.response.status);
      if (error.response.status === 403) {
        setMessage("Wysłałeś już swoją propozycję słuchaczu.");
        setTimeout(() => {
          setButtonState("WYŚLIJ PROPOZYCJE");
        }, 3000);
      }
    }
    console.log(message);
  };

  const onSubmitError = (errors, e) => {
    console.log(errors, Object.entries(errors));
    setButtonState("Robisz coś źle");
    setTimeout(() => {
      setButtonState("WYŚLIJ PROPOZYCJE");
    }, 3000);
  };

  const errorOccurred = Object.keys(errors).length > 0;

	// useEffect(() => {
	// 	navigate('/wyniki')
	// }, [])

  return (
    <div className="p-5 mx-5 bg-gradient-to-b from-[#e2ce9d] to-[#f9b866]">
      <form onSubmit={handleSubmit(handleSubmitForm, onSubmitError)}>
        <div className="max-w-4xl mx-auto">
          <div className="mx-auto mt-5 text-center text-2xl font-[Bold] text-[#503854]">
            ZGŁASZANIE PROPOZYCJI
          </div>

          <div className="p-1 w-full mt-5 drop-shadow-xl bg-[#503854] rounded" />
          <div className="p-1 flex flex-wrap pb-5 justify-around mt-5 drop-shadow-xl bg-[#503854] rounded">
            <div className="p-1 font-[Bold] uppercase text-gray-50">
              podsumowanie roku {prevYear}
            </div>

            <div className="flex flex-wrap justify-around min-w-full">
              <div className="bg-gradient-to-b w-64 from-[#f9b866] to-[#503854] rounded-xl p-1 flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <Controller
                  defaultValue=""
                  rules={{
                    required: {
                      value: true,
                      message: "To pole jest wymagane",
                    },
                    maxLength: {
                      value: 100,
                      message: "maksymalna ilosc znakow to 100",
                    },
                    minLength: {
                      value: 3,
                      message: "minimalna ilosc znakow to 3",
                    },
                  }}
                  control={control}
                  name="artysta"
                  render={({ field }) => {
                    return (
                      <Input
                        {...field}
                        onChange={(e) => field.onChange(e.target.value)}
                        placeholder="Twoja propozycja..."
                        color="info"
                        variant="outlined"
                        autoComplete="off"
                        key="artysta"
                      />
                    );
                  }}
                />
                <div className="font-[Bold] uppercase text-center text-gray-50">
                  artysta
                </div>
              </div>
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] w-64 rounded-xl p-1 flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <Controller
                  rules={{
                    maxLength: {
                      value: 100,
                      message: "maksymalna ilosc znakow to 100",
                    },
                  }}
                  control={control}
                  name="producent"
                  render={({ field }) => {
                    return (
                      <Input
                        {...field}
                        onChange={(e) => field.onChange(e.target.value)}
                        placeholder="Twoja propozycja..."
                        color="info"
                        variant="outlined"
                        autoComplete="off"
                        key="producent"
                      />
                    );
                  }}
                />
                <div className="font-[Bold] uppercase text-center text-gray-50">
                  producent
                </div>
              </div>
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] w-64 rounded-xl p-1 flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <Controller
                  rules={{
                    maxLength: {
                      value: 100,
                      message: "maksymalna ilosc znakow to 100",
                    },
                  }}
                  control={control}
                  name="dj"
                  render={({ field }) => {
                    return (
                      <Input
                        {...field}
                        onChange={(e) => field.onChange(e.target.value)}
                        placeholder="Twoja propozycja..."
                        color="info"
                        variant="outlined"
                        autoComplete="off"
                        key="dj"
                      />
                    );
                  }}
                />
                <div className="font-[Bold] uppercase text-center text-gray-50">
                  dj
                </div>
              </div>
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] w-64 rounded-xl p-1 flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <Controller
                  rules={{
                    maxLength: {
                      value: 100,
                      message: "maksymalna ilosc znakow to 100",
                    },
                  }}
                  control={control}
                  name="album"
                  render={({ field }) => {
                    return (
                      <Input
                        {...field}
                        onChange={(e) => field.onChange(e.target.value)}
                        placeholder="Twoja propozycja..."
                        color="info"
                        variant="outlined"
                        autoComplete="off"
                        key="album"
                      />
                    );
                  }}
                />
                <div className="font-[Bold] uppercase text-center text-gray-50">
                  album
                </div>
              </div>
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] w-64 rounded-xl p-1 flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <Controller
                  rules={{
                    maxLength: {
                      value: 100,
                      message: "maksymalna ilosc znakow to 100",
                    },
                  }}
                  control={control}
                  name="teledysk"
                  render={({ field }) => {
                    return (
                      <Input
                        {...field}
                        onChange={(e) => field.onChange(e.target.value)}
                        placeholder="Twoja propozycja..."
                        color="info"
                        variant="outlined"
                        autoComplete="off"
                        key="teledysk"
                      />
                    );
                  }}
                />
                <div className="font-[Bold] uppercase text-center text-gray-50">
                  teledysk
                </div>
              </div>
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] w-64 rounded-xl p-1 flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <Controller
                  rules={{
                    maxLength: {
                      value: 150,
                      message: "maksymalna ilosc znakow to 150",
                    },
                  }}
                  control={control}
                  name="impreza"
                  render={({ field }) => {
                    return (
                      <Input
                        {...field}
                        onChange={(e) => field.onChange(e.target.value)}
                        placeholder="Twoja propozycja..."
                        color="info"
                        variant="outlined"
                        autoComplete="off"
                        key="impreza"
                      />
                    );
                  }}
                />
                <div className="font-[Bold] uppercase text-center text-gray-50">
                  impreza
                </div>
              </div>
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] w-64 rounded-xl p-1 flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <Controller
                  rules={{
                    maxLength: {
                      value: 150,
                      message: "maksymalna ilosc znakow to 150",
                    },
                  }}
                  control={control}
                  name="wydarzenie"
                  render={({ field }) => {
                    return (
                      <Input
                        {...field}
                        onChange={(e) => field.onChange(e.target.value)}
                        placeholder="Twoja propozycja..."
                        color="info"
                        variant="outlined"
                        autoComplete="off"
                        key="wydarzenie"
                      />
                    );
                  }}
                />
                <div className="font-[Bold] uppercase text-center text-gray-50">
                  wydarzenie
                </div>
              </div>
            </div>
          </div>
          <div className="p-1 flex flex-wrap justify-around">
            <div className="p-1 w-full max-w-2xl mt-5 drop-shadow-xl bg-[#503854] rounded" />
            <div className="px-8 gap-10 max-w-3xl flex-col pb-5 mt-5 drop-shadow-xl bg-[#503854] rounded">
              <div className="bg-gradient-to-b items-center from-[#f9b866] w-60 mx-auto  to-[#503854] rounded-xl p-1 flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <Controller
                  rules={{
                    required: {
                      value: true,
                      message: "To pole jest wymagane",
                    },
                    maxLength: {
                      value: 100,
                      message: "maksymalna ilosc znakow to 100",
                    },
                    minLength: {
                      value: 5,
                      message: "minimalna ilosc znakow to 5",
                    },
                    pattern: {
                      value:
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      message: "ten adres email nie istnieje",
                    },
                  }}
                  control={control}
                  name="email"
                  render={({ field }) => {
                    return (
                      <Input
                        {...field}
                        onChange={(e) => field.onChange(e.target.value)}
                        className="w-full"
                        placeholder="Twój adres email..."
                        color="info"
                        variant="outlined"
                        autoComplete="off"
                        key="email"
                      />
                    );
                  }}
                />
                <div className="p-1 font-[Bold] uppercase text-center text-gray-50">
                  twÓj adres email
                </div>
              </div>
              {Object.keys(errors).length > 0 && (
                <div className="relative">
                  {Object.entries(errors).map((errorEntry) => {
                    return (
                      <span
                        key={errorEntry[0]}
                        className="flex font-bold text-amber-300 uppercase  mt-3"
                      >
                        {errorEntry[1].message !== "" && `${errorEntry[0]}: `}
                        <br />
                        {errorEntry[1].message}
                      </span>
                    );
                  })}
                </div>
              )}

              <div className="mt-5 self-center text-center py-1">
                <Button
                  disabled={errorOccurred}
                  id="submit-proposals-button"
                  type="submit"
                  variant="contained"
                  color="secondary"
                  endIcon={<SendIcon />}
                >
                  <b className="h-7/8 self-end">{buttonState}</b>
                </Button>
              </div>
              {errorOccurred ||
                (message && (
                  <b className="h-7/8 self-end text-[#f9b866]">{message}</b>
                ))}
            </div>
          </div>
          <div className="p-1 mb-3 w-full mt-5 drop-shadow-xl bg-[#503854] rounded" />
        </div>
      </form>
    </div>
  );
};

export default Proposals;
